import React from 'react'

const Project = () => {
    return (

        <div>
            <div className='prodiv'>
                <a target='_blank' href="https://marriageorbit.com/"><img className='imgpro' src="https://sumitjambharkar.netlify.app/assets/imgs/Screenshot%20(119).png" alt="projectone" /></a>
                <a target='_blank' href="https://marriageorbit.com/"><img className='imgpro' src="https://sumitjambharkar.netlify.app/assets/imgs/Screenshot%20(121).png" alt="projecttwo" /></a>
                <a target='_blank' href="https://play.google.com/store/apps/details?id=com.marriage.marriageorbit&pli=1"><img className='imgpro' src="https://sumitjambharkar.netlify.app/assets/imgs/Screenshot%20(123).png" alt="projectthree" /></a>

            </div>
            <div className='prodiv'>
            <a target='_blank' href="https://restaurantbar.netlify.app/"><img className='imgpro' src="https://sumitjambharkar.netlify.app/assets/imgs/Screenshot%20(120).png" alt="projectthree" /></a>
            <a target='_blank' href="https://cleannation.in/"><img className='imgpro' src="https://sumitjambharkar.netlify.app/assets/imgs/Screenshot%20(122).png" alt="projectone" /></a>
            <a target='_blank' href="https://starhomeinterior.com/"><img className='imgpro' src="https://sumitjambharkar.netlify.app/assets/imgs/Screenshot%20(124).png" alt="projectsix" /></a>
            </div>
        </div>

    )
}

export default Project